import React, { forwardRef } from 'react';

const rtl = document.getElementsByTagName('html')[0].getAttribute('dir');
const withDirection = Component => forwardRef((props, ref) => {
  return <Component {...props} ref={ref} data-rtl={rtl} />;
});

export default withDirection;
export { rtl };
